import React, {useRef, useState, useEffect, useCallback} from 'react'
import {Form, Input, Button} from 'antd'

import { utils_tool } from '@/tool'


import {WizTableForm} from "@/containers/common";

const userConfig = WizTableForm.Config.user(this, {apiParams: {}}, {
  rowName: (item) => {
    let {fullName, userName, personId} = item || {}
    return fullName || userName || personId
  }
})

const formItemLayout = {
  labelCol: {span: 3},
  wrapperCol: {span: 14},
};

/**
 * 用于解决重置不重新渲染问题
 *
 * @param value
 * @param onChange
 * @param props
 * @returns {Element}
 * @constructor
 */
const WizTableFormPlus = ({keyprefix,value, onChange, ...props}) => {
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const [data, setData] = useState(value)
  const {rowkey} = props || {}
  const isArray = data instanceof Array;
  const key = isArray ? data?.map(item => item[rowkey]) : data?.[rowkey]

  useEffect(() => {
    console.log('value ---->', value)
    setData(value)
    setTimestamp(new Date().getTime())
  }, [value]);

  useEffect(() => {
    console.log('data ---->', data, value)
    // onChange && onChange(data)
    if(!utils_tool.isEqual(data, value)) {
      onChange && onChange(data)
    }
  }, [data]);

  return (
    <WizTableForm
      key={[keyprefix, timestamp].filter(item => !!item).join('_')}
      {...props}
      selectType={'radio'}
      value={key}
      onChange={(key, rows) => {
        setData(rows)
        onChange && onChange(rows)
      }}
      initRows={data ? (isArray ? data : [data]) : []}
    />
  )
}


const Add = ({form, submit, ...props}) => {
  const {getFieldDecorator, validateFields, resetFields} = form

  const onSubmit = useCallback(() => {
    validateFields((err, values) => {
      if (!err) {
        submit && submit(values);
      }
    });
  }, [submit])

  return (
    <Form {...formItemLayout}>
      <Form.Item label="旧账号">
        {
          getFieldDecorator('personIdOld', {
            rules: [
              {required: true, message: '旧账号不能为空'}
            ]
          })(<WizTableFormPlus keyprefix={'old'} {...userConfig}/>)
        }
      </Form.Item>
      <Form.Item label="新账号">
        {
          getFieldDecorator('personIdNew', {
            rules: [
              {required: true, message: '新账号不能为空'}
            ]
          })(<WizTableFormPlus keyprefix={'new'} {...userConfig}/>)
        }
      </Form.Item>
      <Form.Item wrapperCol={{span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span}}>
        <Button  onClick={() => resetFields()}>重置</Button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Button onClick={() => onSubmit()}>确认合并</Button>
      </Form.Item>
    </Form>
  )
}


const AddForm = Form.create()(Add)

export {
  AddForm,
}
